/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { OdataTermineResponse } from '../models/odata-termine-response';
import { OdataTermineRequest } from '../models/odata-termine-request';
import { OdataTermineAktRequest } from '../models/odata-termine-akt-request';
import { FairAppSimpleRequest } from '../models/fair-app-simple-request';
import { OdataTerminCreateResponse } from '../models/odata-termin-create-response';
import { OdataTerminCreateRequest } from '../models/odata-termin-create-request';
import { OdataKundenterminBestaetigenRequest } from '../models/odata-kundentermin-bestaetigen-request';
import { OdataKundenterminEmailSendenRequest } from '../models/odata-kundentermin-email-senden-request';
import { OdataKundenterminWeitersetzenRequest } from '../models/odata-kundentermin-weitersetzen-request';
@Injectable({
  providedIn: 'root',
})
class TermineService extends __BaseService {
  static readonly termineOdataCreatePath = '/termine/odata/';
  static readonly termineOdataAktCreatePath = '/termine/odata/akt';
  static readonly termineOdataAktBerichtCreatePath = '/termine/odata/akt/bericht';
  static readonly termineOdataAktBerichturCreatePath = '/termine/odata/akt/berichtur';
  static readonly termineOdataAktKundenterminCreatePath = '/termine/odata/akt/kundentermin';
  static readonly termineOdataCreateCreatePath = '/termine/odata/create';
  static readonly termineOdataKundenterminBestaetigenCreatePath = '/termine/odata/kundentermin/bestaetigen';
  static readonly termineOdataKundenterminEmailsendenCreatePath = '/termine/odata/kundentermin/emailsenden';
  static readonly termineOdataKundenterminWeitersetzenCreatePath = '/termine/odata/kundentermin/weitersetzen';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param data undefined
   */
  termineOdataCreateResponse(data: OdataTermineRequest): __Observable<__StrictHttpResponse<Array<OdataTermineResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/termine/odata/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<OdataTermineResponse>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  termineOdataCreate(data: OdataTermineRequest): __Observable<Array<OdataTermineResponse>> {
    return this.termineOdataCreateResponse(data).pipe(
      __map(_r => _r.body as Array<OdataTermineResponse>)
    );
  }

  /**
   * @param data undefined
   */
  termineOdataAktCreateResponse(data: OdataTermineAktRequest): __Observable<__StrictHttpResponse<OdataTermineAktRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/termine/odata/akt`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataTermineAktRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  termineOdataAktCreate(data: OdataTermineAktRequest): __Observable<OdataTermineAktRequest> {
    return this.termineOdataAktCreateResponse(data).pipe(
      __map(_r => _r.body as OdataTermineAktRequest)
    );
  }

  /**
   * @param data undefined
   */
  termineOdataAktBerichtCreateResponse(data: FairAppSimpleRequest): __Observable<__StrictHttpResponse<FairAppSimpleRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/termine/odata/akt/bericht`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FairAppSimpleRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  termineOdataAktBerichtCreate(data: FairAppSimpleRequest): __Observable<FairAppSimpleRequest> {
    return this.termineOdataAktBerichtCreateResponse(data).pipe(
      __map(_r => _r.body as FairAppSimpleRequest)
    );
  }

  /**
   * @param data undefined
   */
  termineOdataAktBerichturCreateResponse(data: FairAppSimpleRequest): __Observable<__StrictHttpResponse<FairAppSimpleRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/termine/odata/akt/berichtur`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FairAppSimpleRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  termineOdataAktBerichturCreate(data: FairAppSimpleRequest): __Observable<FairAppSimpleRequest> {
    return this.termineOdataAktBerichturCreateResponse(data).pipe(
      __map(_r => _r.body as FairAppSimpleRequest)
    );
  }

  /**
   * @param data undefined
   */
  termineOdataAktKundenterminCreateResponse(data: FairAppSimpleRequest): __Observable<__StrictHttpResponse<FairAppSimpleRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/termine/odata/akt/kundentermin`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FairAppSimpleRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  termineOdataAktKundenterminCreate(data: FairAppSimpleRequest): __Observable<FairAppSimpleRequest> {
    return this.termineOdataAktKundenterminCreateResponse(data).pipe(
      __map(_r => _r.body as FairAppSimpleRequest)
    );
  }

  /**
   * @param data undefined
   */
  termineOdataCreateCreateResponse(data: OdataTerminCreateRequest): __Observable<__StrictHttpResponse<OdataTerminCreateResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/termine/odata/create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataTerminCreateResponse>;
      })
    );
  }
  /**
   * @param data undefined
   */
  termineOdataCreateCreate(data: OdataTerminCreateRequest): __Observable<OdataTerminCreateResponse> {
    return this.termineOdataCreateCreateResponse(data).pipe(
      __map(_r => _r.body as OdataTerminCreateResponse)
    );
  }

  /**
   * @param data undefined
   */
  termineOdataKundenterminBestaetigenCreateResponse(data: OdataKundenterminBestaetigenRequest): __Observable<__StrictHttpResponse<OdataKundenterminBestaetigenRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/termine/odata/kundentermin/bestaetigen`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataKundenterminBestaetigenRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  termineOdataKundenterminBestaetigenCreate(data: OdataKundenterminBestaetigenRequest): __Observable<OdataKundenterminBestaetigenRequest> {
    return this.termineOdataKundenterminBestaetigenCreateResponse(data).pipe(
      __map(_r => _r.body as OdataKundenterminBestaetigenRequest)
    );
  }

  /**
   * @param data undefined
   */
  termineOdataKundenterminEmailsendenCreateResponse(data: OdataKundenterminEmailSendenRequest): __Observable<__StrictHttpResponse<OdataKundenterminEmailSendenRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/termine/odata/kundentermin/emailsenden`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataKundenterminEmailSendenRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  termineOdataKundenterminEmailsendenCreate(data: OdataKundenterminEmailSendenRequest): __Observable<OdataKundenterminEmailSendenRequest> {
    return this.termineOdataKundenterminEmailsendenCreateResponse(data).pipe(
      __map(_r => _r.body as OdataKundenterminEmailSendenRequest)
    );
  }

  /**
   * @param data undefined
   */
  termineOdataKundenterminWeitersetzenCreateResponse(data: OdataKundenterminWeitersetzenRequest): __Observable<__StrictHttpResponse<OdataKundenterminWeitersetzenRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/termine/odata/kundentermin/weitersetzen`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataKundenterminWeitersetzenRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  termineOdataKundenterminWeitersetzenCreate(data: OdataKundenterminWeitersetzenRequest): __Observable<OdataKundenterminWeitersetzenRequest> {
    return this.termineOdataKundenterminWeitersetzenCreateResponse(data).pipe(
      __map(_r => _r.body as OdataKundenterminWeitersetzenRequest)
    );
  }
}

module TermineService {
}

export { TermineService }
